import { partnerRequest } from '../services/request.service'

const API_URL = window.env ? window.env.API_SERVER : '';
const NO_CONTENT = 2;
const REQUEST_FAILURE = 1;
const REQUEST_SUCCESS = 0;

const impactStatementsRequest = 'JOURNAL_LIST_REQUEST';
const impactStatementsSuccess = 'JOURNAL_LIST_SUCCESS';
const impactStatementsFailure = 'JOURNAL_LIST_FAILURE';

const impactBillSuccess = "IMPACT_BILL_SUCCESS";

const initialState = {
    impactStatements: [],
    impactStatementMessage: '',
    impactStatementBill: ""
};

export const impactStatementActionCreators = {
    requestImpactStatements: () => ({
        type: impactStatementsRequest,
        impactStatements: [],
        isFetching: true
    }),

    receiveImpactStatements: (statements) => ({
        type: impactStatementsSuccess,
        isFetching: false,
        impactStatements: statements
    }),

    impactStatementsError: (message) => ({
        type: impactStatementsFailure,
        isFetching: false,
        impactStatements: [],
        impactStatementsMessage: message
    }),

    getImpactStatements: (body) => {
        return dispatch => {
            dispatch(impactStatementActionCreators.requestImpactStatements());

            let headers = {
                'content-type': "application/json; charset=utf-8"
            }
            return partnerRequest((API_URL || process.env.REACT_APP_JOURNAL_API_URL) + '/Legislation/api/GetFiscalImpactStatements', 'POST', headers, body, '')
                .then(result => {
                    if (result[0] === REQUEST_FAILURE) {
                        dispatch(impactStatementActionCreators.impactStatementsError(result[1]))
                        return Promise.reject(result[1])
                    } else if (result[0] === REQUEST_SUCCESS) {
                        // Dispatch the success action
                        dispatch(impactStatementActionCreators.receiveImpactStatements(result[1].FiscalImpacts))
                    } else if (result[0] === NO_CONTENT) {
                        dispatch(impactStatementActionCreators.receiveImpactStatements([]));
                    } else if (result.name === 'AbortError') {
                        return Promise.reject("Aborted");
                    }
                }).catch(err => Promise.reject(err))
        }
    },

    setImpactStatementBill: (impactStatementBillNumber) => ({
        type: impactBillSuccess,
        impactStatementBill: impactStatementBillNumber
    }),

    setImpactBill: (impactStatementBillNumber) => {
        return dispatch => {
            dispatch(impactStatementActionCreators.setImpactStatementBill(impactStatementBillNumber))
        }
    }
}

export const reducer = (state, action) => {

    state = state || initialState;

    switch (action.type) {
        case impactStatementsRequest:
            return Object.assign({}, state, {
                isFetching: true
            })
        case impactStatementsSuccess:
            return Object.assign({}, state, {
                isFetching: false,
                impactStatements: action.impactStatements,
                impactStatementMessage: ''
            })
        case impactStatementsFailure:
            return Object.assign({}, state, {
                isFetching: false,
                impactStatements: action.impactStatements,
                impactStatementsMessage: action.impactStatementsMessage
            })
        case impactBillSuccess:
            return Object.assign({}, state, {
                impactStatementBill: action.impactStatementBill
            })
        default:
            return state
    }
};